import React, { SyntheticEvent } from 'react';

import { ActionDropdownItem } from '@components/library/dropdown_item/index';

interface DropdownContents {
  content: string | JSX.Element;
  icon?: string;
  isDisplayed?: boolean;
  onChoose?: (name: Name, e: SyntheticEvent) => void;
  name: string | number;
}
type Name = string | number;

const dropdownContents: DropdownContents[] = [
  {
    icon: 'bff-edit',
    isDisplayed: true,
    name: 'rename',
    onChoose: (name, e): void => console.log('rename selected!', e, { name }),
    content: 'Rename',
  },
  {
    icon: 'bff-upload',
    isDisplayed: true,
    name: 'replace',
    onChoose: (name, e): void => console.log('replace selected!', e, { name }),
    content: 'Replace',
  },
  {
    icon: 'bff-trash',
    isDisplayed: true,
    name: 'delete',
    onChoose: (name, e): void => console.log('delete selected!', e, { name }),
    content: 'Delete',
  }
];

export const actionItems = dropdownContents.map((item) => (
  <ActionDropdownItem
    icon={item.icon}
    key={item.name}
    name={item.name}
    onChoose={item.onChoose}
  >
    {item.content}
  </ActionDropdownItem>
));

export const listOptions = [
  { label: 'Really Long Item that overruns the container', value: 'Hi!' },
  { label: 'Position', value: 'position' },
  { label: 'Created', value: 'created' },
  { label: 'Updated', value: 'updated' },
  { label: 'Favorite Number', value: 1 },
  { label: 'Least Favorite Number', value: 0 },
  { label: 'Blue', value: 'blue' },
  { label: 'Red', value: 'red' },
];
